import React from "react"
import { Outlet } from "react-router-dom";

import MDBox from "materialDashboard/components/MDBox";
import Navbar from "./Navbar";
import Sidenav from "./Sidenav";


// Images
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";
import {useMaterialUIController} from "../materialDashboard/context";
import {useAuth} from "../auth/AuthProvider";


const MainLayout = () => {
    const [controller] = useMaterialUIController();
    const {authorizationsLoaded} = useAuth();

    const {
        miniSidenav,
        sidenavColor,
        transparentSidenav,
        whiteSidenav,
        darkMode,
    } = controller;

    // TODO add a loading indicator
    if (!authorizationsLoaded){
        return null;
    }

    return <MDBox
        sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
            p: {
                sm: 1,
                xs: 0.5,
            },
            position: "relative",
            minHeight: "100vh",

            [breakpoints.up("xl")]: {
                marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
                transition: transitions.create(["margin-left", "margin-right"], {
                    easing: transitions.easing.easeInOut,
                    duration: transitions.duration.standard,
                }),
            },
        })}
    >
        <Sidenav color={sidenavColor}
                 brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
                 brandName="YetiWeb"/>
        <Navbar/>

        <Outlet/>
    </MDBox>
}



export default MainLayout